import React from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
import { Tooltip as TooltipBs, TooltipProps as TooltipPropsBs } from '@bootstrap-styled/v4'
import { omit } from 'ramda'
import Color from '@bootstrap-styled/color'

//type definition
export type TooltipProps = {
    color?: 'active' | 'pending'
} & TooltipPropsBs

const Tooltip = styled(
    (attrs: TooltipProps): JSX.Element => <TooltipBs {...omit(['color', 'pendingColor'], attrs)} />
).attrs(props => ({
    className: classNames(props.className, {
        [`tooltip-${props.color}`]: !!props.color
    }),
    pendingColor: Color(props.theme['$primary'])
        .lightness(60)
        .string()
}))`
    && {
        .tooltip-inner {
            border-radius: ${props => props.theme['$tooltip-border-radius']};
            line-height: 1.1;
            font-weight: ${props => props.theme['$font-weight-medium']};

            &:focus {
                outline: none;
            }
        }

        &.bs-tether-element-attached-bottom  {
            margin-bottom: 5px;
        }

        &.bs-tether-element-attached-top {
            margin-top: 5px;
        }

        &.bs-tether-element-attached-left {
            margin-left: 5px;
        }

        &.bs-tether-element-attached-right {
            margin-left: -5px;
        }
    }

    /* Custom colors */
    &.tooltip-active {
        .tooltip-inner {
            background-color: ${props => props.theme['$teal']};
            color: ${props => props.theme['$white']};
        }

        &.bs-tether-element-attached-bottom  {
            margin-bottom: 2px;
        }

        &.bs-tether-element-attached-top {
            margin-top: 2px;
        }

        &.bs-tether-element-attached-left {
            margin-left: 2px;
        }

        &.bs-tether-element-attached-right {
            margin-left: -2px;
        }

        &.bs-tether-element-attached-bottom .tooltip-inner::before {
            border-top-color: ${props => props.theme['$teal']};
        }

        &.bs-tether-element-attached-top .tooltip-inner::before {
            border-bottom-color: ${props => props.theme['$teal']};
        }

        &.bs-tether-element-attached-left .tooltip-inner::before {
            border-right-color: ${props => props.theme['$teal']};
        }

        &.bs-tether-element-attached-right .tooltip-inner::before {
            border-left-color: ${props => props.theme['$teal']};
        }
    }

    &.tooltip-pending {
        .tooltip-inner {
            background-color: ${props => props.pendingColor};
            color: ${props => props.theme['$white']};
        }

        &.bs-tether-element-attached-bottom  {
            margin-top: -2px;
        }

        &.bs-tether-element-attached-top {
            margin-top: 2px;
        }

        &.bs-tether-element-attached-left {
            margin-left: 2px;
        }

        &.bs-tether-element-attached-right {
            margin-left: -2px;
        }

        &.bs-tether-element-attached-bottom .tooltip-inner::before {
            border-top-color: ${props => props.pendingColor};
        }

        &.bs-tether-element-attached-top .tooltip-inner::before {
            border-bottom-color: ${props => props.pendingColor};
        }

        &.bs-tether-element-attached-left .tooltip-inner::before {
            border-right-color: ${props => props.pendingColor};
        }

        &.bs-tether-element-attached-right .tooltip-inner::before {
            border-left-color: ${props => props.pendingColor};
        }
    }
`
export default Tooltip
